// extracted by mini-css-extract-plugin
export default {"interestAccrued":"InterestAccrued_interestAccrued","title":"InterestAccrued_title","money":"InterestAccrued_money"};